<template>
  <Teleport to="body">
    <div :class="open ? 'blurry' : ''">
      <TransitionRoot as="template" :show="open">
        <Dialog as="div" class="relative z-40" @close="open = false">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="ease-in duration-200"
            leave-from="opacity-100"
            leave-to="opacity-0">
            <div class="fixed inset-0 bg-quinary opacity-75 transition-opacity" />
          </TransitionChild>
          <div class="fixed inset-0 z-10 overflow-y-auto">
            <div class="relative flex min-h-full justify-center p-4 text-left items-center lg:p-0">
              <TransitionChild
                as="template"
                enter="ease-out duration-300"
                enter-from="opacity-0 translate-y-4 lg:translate-y-0 lg:scale-95"
                enter-to="opacity-100 translate-y-0 lg:scale-100"
                leave="ease-in duration-200"
                leave-from="opacity-100 translate-y-0 lg:scale-100"
                leave-to="opacity-0 translate-y-4 lg:translate-y-0 lg:scale-95">
                <DialogPanel
                  class="absolute transform overflow-hidden rounded-lg bg-surface text-left shadow-xl transition-all lg:max-w-xl top-50">
                  <div class="bg-background px-4 pt-5 pb-4 lg:p-6 lg:pb-4">
                    <div class="lg:flex lg:items-start">
                      <div class="m-3 text-left lg:mt-0 lg:ml-4 lg:text-left">
                        <DialogTitle as="h3"
                          ><span class="text-2xl font-semibold leading-6 text-gray-900">{{
                            $t("This is a read only version")
                          }}</span></DialogTitle
                        >
                        <div class="mt-2">
                          <p class="mt-3 text-base text-focus">
                            {{
                              $t(
                                "Welcome to the demo portal. We have sent you an email with further instructions to activate your account. But in the meantime you can already browse in this demo portal to view our tickets."
                              )
                            }}
                          </p>
                          <div class="my-6">
                            <button
                              class="disabled:bg-disabled disabled:text-background disabled:shadow-none bg-primary py-2 rounded accent-primary hover:shadow active:shadow-sm px-8"
                              @click="open = false">
                              {{ $t("Experience the read-only version of our portal") }}
                            </button>
                          </div>
                          <p class="mt-3">
                            {{ $t("If you have any questions, drop us a line at") }} support@xs2event.com.
                          </p>
                        </div>
                        <div class="flex flex-wrap -mx-3 -mb-2 mt-8">
                          <div class="w-full lg:w-1/4 px-3 lg:mb-0">
                            <div
                              class="border-white border-2 float-left bg-primary w-20 h-20 rounded-full flex justify-center items-center"
                              style="
                                background-image: url(&quot;https://cdn.xs2event.com/media-production/profiles/rene.png&quot;);
                                background-position: center;
                                background-size: cover;
                              "></div>
                            <div
                              class="absolute border-white border-2 ml-14 bg-primary w-20 h-20 rounded-full flex justify-center items-center"
                              style="
                                background-image: url(&quot;https://cdn.xs2event.com/media-production/profiles/jeroen.png&quot;);
                                background-position: center;
                                background-size: cover;
                              "></div>
                          </div>
                          <div class="w-full lg:w-3/4 px-3 -mb-2 mt-3">
                            <div class="w-full px-3">
                              <p>
                                <b>{{ $t("Rene & Jeroen") }}</b>
                              </p>
                              <p>{{ $t("Founders XS2Event") }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </TransitionRoot>
    </div>
  </Teleport>
</template>

<script setup>
import { ref } from "vue";
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";

const open = ref(true);
</script>

<style>
.blurry {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 40;
}
</style>
